import type { GetDataCompletenessResponseDto } from '@/src/api/types/generated-types'

export type DataCompletenessScope = GetDataCompletenessResponseDto['scope']

export const DEFAULT_DATA_COMPLETENESS_SCOPE: DataCompletenessScope = 'company'

export type MappedDataCompletenessDataPoint = {
  startTime: string
  endTime: string
  completenessPercentage: number
}

export type MappedDataCompletenessItem = {
  id: number
  title: string
  sourceId?: string
  sourceType?: string
  completenessPercentage: number | null | undefined
  data: MappedDataCompletenessDataPoint[] | null | undefined
}

export type MappedDataCompletenessIndicatorData = {
  scope: DataCompletenessScope
  qualityPercentage: number | null | undefined
  items: MappedDataCompletenessItem[]
}

const emptyMappedDataCompletenessIndicatorData: MappedDataCompletenessIndicatorData = {
  scope: DEFAULT_DATA_COMPLETENESS_SCOPE,
  qualityPercentage: 0,
  items: [],
}

export const mapDataCompletenessResponse = (response: GetDataCompletenessResponseDto | undefined): MappedDataCompletenessIndicatorData => {
  if (!response) return emptyMappedDataCompletenessIndicatorData

  return {
    scope: response.scope,
    qualityPercentage: response.completenessPercentage,
    items: response.items.map((item, index) => {
      const itemWithSource = item as typeof item & { sourceId?: string; sourceType?: string }

      return {
        id: index,
        title: item.name,
        sourceId: itemWithSource.sourceId,
        sourceType: itemWithSource.sourceType,
        completenessPercentage: item.completenessPercentage,
        data:
          item.intervalsCompletenessData == null
            ? item.intervalsCompletenessData
            : item.intervalsCompletenessData.map(interval => ({
                startTime: interval.startTime,
                endTime: interval.endTime,
                completenessPercentage: interval.completenessPercentage,
              })),
      }
    }),
  }
}
